import { Products } from '@zencity/customer-management-client';
import { DEFINITION_KEY_PREFIX } from 'screens/WidgetGenerator/reportGeneratorComponents/constants';

export const productPrefixDefinitionKey = (definitionKey: string, product: Products): string => {
  const prefix = DEFINITION_KEY_PREFIX[product];
  if (!prefix) {
    throw new Error(`Failed to find a data item definition prefix for product: ${product}`);
  }

  return `${prefix}-${definitionKey}`;
};
